<template>
  <div>
    <b-row class="no-gutters justify-content-center container-fluid my-5">
      <b-col cols="12" md="6" sm="10">
        <div class="mb-5">
          <h5>
            Créer un utilisateur
          </h5>
        </div>
        <UsersForm :visibleRole="true"></UsersForm>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * @file       User creation component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import UsersForm from "@/modules/admin/components/usersForm.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  components: { UsersForm }
};
</script>

<style lang="scss" scoped></style>
